import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

// Markdown → the plain text a manager would paste into an email or a text.
export const markdownToPlain = (md) => (md || "")
  .replace(/```[\s\S]*?```/g, (m) => m.replace(/```\w*\n?/g, ""))
  .replace(/^#{1,6}\s+/gm, "")
  .replace(/\*\*([^*]+)\*\*/g, "$1")
  .replace(/(^|[^*])\*([^*\n]+)\*/g, "$1$2")
  .replace(/_([^_\n]+)_/g, "$1")
  .replace(/^\s*[-*]\s+/gm, "• ")
  .replace(/\[([^\]]+)\]\(([^)]+)\)/g, (m, t, h) => (h.startsWith("/") ? t : `${t} (${h})`))
  .replace(/\n{3,}/g, "\n\n")
  .trim();

export async function copyText(text, okMsg = "Copied") {
  try {
    if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
    else {
      const ta = document.createElement("textarea");
      ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    toast.success(okMsg);
    return true;
  } catch {
    toast.error("Couldn't copy — select the text and copy it yourself.");
    return false;
  }
}

export function CopyButton({ text, plain = true, label = "Copy", testid = "copilot-copy", className = "" }) {
  const [done, setDone] = useState(false);
  const onClick = async () => {
    if (await copyText(plain ? markdownToPlain(text) : text)) {
      setDone(true);
      setTimeout(() => setDone(false), 1500);
    }
  };
  return (
    <button data-testid={testid} onClick={onClick} title="Copy to clipboard" aria-label="Copy to clipboard"
      className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-[11px] font-semibold text-ink/50 hover:text-ink hover:bg-sand-100 transition-colors ${className}`}>
      {done ? <Check className="h-3.5 w-3.5 text-emerald-600" strokeWidth={2.5} /> : <Copy className="h-3.5 w-3.5" strokeWidth={2} />}
      {label && <span>{done ? "Copied" : label}</span>}
    </button>
  );
}
